module.exports = __webpack_public_path__ + "static/media/Review_Assissment.4b514176.png";